import { NavLink, Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '../../../stores/auth.store';

/**
 * Shell for /dashboard/restricted/*. Renders a sub-nav across the top and the
 * matched child route below. The outer AppLayout already handles the global
 * sidebar + topbar.
 */
export function RestrictedLayout() {
  const email = useAuthStore((s) => s.user?.email);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)' }}>
      <header>
        <p style={{ margin: 0, fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-warning)', fontWeight: 'var(--font-weight-semibold)', textTransform: 'uppercase', letterSpacing: 'var(--tracking-caps)' }}>
          Super-admin · restricted
        </p>
        <h1 style={{ marginTop: 'var(--space-1)', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-weight-bold)', color: 'var(--color-text-brand)', letterSpacing: 'var(--tracking-tight)' }}>
          System
        </h1>
        <p style={{ marginTop: 'var(--space-1)', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-md)', color: 'var(--color-text-muted)' }}>
          Cross-org administration. Signed in as <code>{email}</code>.
        </p>
      </header>

      <nav style={{ display: 'flex', gap: 'var(--space-2)', borderBottom: '1px solid var(--color-border-default)', paddingBottom: 'var(--space-2)' }}>
        <Tab to="/dashboard/restricted/organisations">Organisations</Tab>
        <Tab to="/dashboard/restricted/accounts">Accounts</Tab>
        <Tab to="/dashboard/restricted/system">System</Tab>
      </nav>

      <Outlet />
    </div>
  );
}

function Tab({ to, children }: { to: string; children: ReactNode }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        padding: 'var(--space-2) var(--space-3)',
        borderRadius: 'var(--btn-radius)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 'var(--font-weight-semibold)',
        color: isActive ? 'var(--color-text-brand)' : 'var(--color-text-muted)',
        backgroundColor: isActive ? 'var(--color-sidebar-active-bg)' : 'transparent',
        textDecoration: 'none',
      })}
    >
      {children}
    </NavLink>
  );
}
